
import React from "react";
import { FormInput } from "@/components/ui/form-input";
import { LoadingButton } from "@/components/ui/loading-button";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import TwilioErrorAlert from "./number/TwilioErrorAlert";
import { AuthTokenInput } from "./AuthTokenInput";

type Props = {
  error: string | null;
  validated: boolean;
  accountSid: string;
  setAccountSid: (sid: string) => void;
  authToken: string;
  setAuthToken: (token: string) => void;
  hasMaskedDbToken: boolean;
  revealToken: boolean;
  setRevealToken: (reveal: boolean) => void;
  loading: boolean;
  handleValidate: () => void;
};

const AgencyTwilioCredentialsForm: React.FC<Props> = ({
  error,
  validated,
  accountSid,
  setAccountSid,
  authToken,
  setAuthToken,
  hasMaskedDbToken,
  revealToken,
  setRevealToken,
  loading,
  handleValidate,
}) => (
  <form className="space-y-4" onSubmit={e => { e.preventDefault(); handleValidate(); }}>
    {error && <TwilioErrorAlert error={error} />}
    {validated && (
      <Alert>
        <AlertTitle>Success</AlertTitle>
        <AlertDescription>Twilio credentials validated successfully!</AlertDescription>
      </Alert>
    )}
    <FormInput
      label="Twilio Account SID"
      value={accountSid}
      onChange={e => setAccountSid(e.target.value)}
      required
      placeholder="ACXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
    />
    <AuthTokenInput
      value={authToken}
      onChange={e => setAuthToken(e.target.value)}
      masked={hasMaskedDbToken}
      revealed={revealToken}
      onToggleReveal={() => setRevealToken(!revealToken)}
      showToggleButton={hasMaskedDbToken || authToken.length > 0}
    />
    <LoadingButton type="submit" loading={loading}>
      {validated ? "Continue" : "Validate & Continue"}
    </LoadingButton>
    <div className="text-xs mt-2">
      <a
        href="https://www.twilio.com/console/project/api-keys"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >Tip: Generate a restricted API Key & Secret for extra security
      </a>
    </div>
  </form>
);

export default AgencyTwilioCredentialsForm;
